import Form from './form.element.js';

export default Form;

Form.define('wje-form', Form);
